export const cookiesTranslations = {
  en: {
    header: "Cookie Policy",
    contents: {
      header: "Contents",
      listItems: [
        "What are cookies?",
        "How Innaxys uses cookies",
        "Third-party cookies",
        "What are your choices regarding cookies",
        "How to control cookies",
      ],
    },
    intro: [
      "Innaxys Ltd (“us”, “we”, or “our”) uses cookies on innaxys.com (the “Service”). By using the Service, you consent to the use of cookies.",
      "Our Cookies Policy explains what cookies are, how we use cookies, how third-parties we may partner with may use cookies on the Service, your choices regarding cookies and further information about cookies.",
    ],
    contexts: [
      {
        header: "How Innaxys uses cookies?",
        text: [
          "When you use and access the Service, we may place a number of cookies files in your web browser.",
          "We use cookies for the following purposes: to enable certain functions of the Service, to provide analytics, to store your preferences.",
          "We use both session and persistent cookies on the Service and we use different types of cookies to run the Service:",
        ],
        textList: [
          "Essential cookies. We may use essential cookies to authenticate users and prevent fraudulent use of user accounts.",
          "Non-essential cookies: We use third party cookies to count the number of visitors to our website.",
        ],
      },
      {
        header: "Third-party cookies",
        text: "In addition to our own cookies, we may also use various third-parties cookies to report usage statistics of the Service, deliver advertisements on and through the Service, and so on.",
      },
      {
        header: "What are your choices regarding cookies",
        text: [
          "If you’d like to delete cookies or instruct your web browser to delete or refuse cookies, please visit the help pages of your web browser.",
          "Please note, however, that if you delete cookies or refuse to accept them, you might not be able to use all of the features we offer, you may not be able to store your preferences, and some of our pages might not display properly.",
        ],
      },
      {
        header: "How to control cookies",
        text: "You can control and/or delete cookies as you wish – for details, see aboutcookies.org. You can delete all cookies that are already on your computer and you can set most browsers to prevent them from being placed. If you do this, however, you may have to manually adjust some preferences every time you visit a site and some services and functionalities may not work.",
      },
    ],
  },
  fr: {
    header: "Politique de cookies",
    contents: {
      header: "Contenu",
      listItems: [
        "Que sont les cookies ?",
        "Comment Innaxys utilise les cookies",
        "Cookies tiers",
        "Quels sont vos choix concernant les cookies",
        "Comment contrôler les cookies"
      ]
    },
    intro: [
      "Innaxys Ltd (« nous », « notre » ou « nos ») utilise des cookies sur innaxys.com (le « Service »). En utilisant le Service, vous consentez à l'utilisation des cookies.",
      "Notre politique de cookies explique ce que sont les cookies, comment nous les utilisons, comment des tiers partenaires peuvent les utiliser sur le Service, vos choix concernant les cookies et des informations supplémentaires à leur sujet."
    ],
    contexts: [
      {
        header: "Comment Innaxys utilise les cookies ?",
        text: [
          "Lorsque vous utilisez et accédez au Service, nous pouvons placer un certain nombre de fichiers cookies dans votre navigateur web.",
          "Nous utilisons des cookies aux fins suivantes : activer certaines fonctions du Service, fournir des analyses, stocker vos préférences.",
          "Nous utilisons à la fois des cookies de session et des cookies persistants sur le Service, et nous utilisons différents types de cookies pour faire fonctionner le Service :"
        ],
        textList: [
          "Cookies essentiels. Nous pouvons utiliser des cookies essentiels pour authentifier les utilisateurs et prévenir l'utilisation frauduleuse des comptes utilisateurs.",
          "Cookies non essentiels : Nous utilisons des cookies tiers pour compter le nombre de visiteurs sur notre site web."
        ]
      },
      {
        header: "Cookies tiers",
        text: "En plus de nos propres cookies, nous pouvons également utiliser divers cookies tiers pour rapporter les statistiques d'utilisation du Service, diffuser des publicités sur et via le Service, etc."
      },
      {
        header: "Quels sont vos choix concernant les cookies",
        text: [
          "Si vous souhaitez supprimer les cookies ou demander à votre navigateur web de les supprimer ou de les refuser, veuillez consulter les pages d'aide de votre navigateur.",
          "Veuillez noter, cependant, que si vous supprimez les cookies ou refusez de les accepter, vous pourriez ne pas être en mesure d'utiliser toutes les fonctionnalités que nous offrons, vous pourriez ne pas être en mesure de stocker vos préférences, et certaines de nos pages pourraient ne pas s'afficher correctement."
        ]
      },
      {
        header: "Comment contrôler les cookies",
        text: "Vous pouvez contrôler et/ou supprimer les cookies comme vous le souhaitez – pour plus de détails, consultez aboutcookies.org. Vous pouvez supprimer tous les cookies déjà présents sur votre ordinateur et vous pouvez configurer la plupart des navigateurs pour empêcher leur placement. Cependant, si vous faites cela, vous devrez peut-être ajuster manuellement certaines préférences chaque fois que vous visitez un site, et certains services et fonctionnalités peuvent ne pas fonctionner."
      }
    ]
  },
  de: {
    header: "Cookie-Richtlinie",
    contents: {
      header: "Inhalt",
      listItems: [
        "Was sind Cookies?",
        "Wie Innaxys Cookies verwendet",
        "Cookies von Drittanbietern",
        "Welche Wahlmöglichkeiten haben Sie bezüglich Cookies",
        "Wie man Cookies kontrolliert"
      ]
    },
    intro: [
      "Innaxys Ltd („wir“, „uns“ oder „unser“) verwendet Cookies auf innaxys.com (der „Dienst“). Durch die Nutzung des Dienstes stimmen Sie der Verwendung von Cookies zu.",
      "Unsere Cookie-Richtlinie erklärt, was Cookies sind, wie wir Cookies verwenden, wie Drittanbieter, mit denen wir möglicherweise zusammenarbeiten, Cookies auf dem Dienst verwenden, Ihre Wahlmöglichkeiten bezüglich Cookies und weitere Informationen über Cookies."
    ],
    contexts: [
      {
        header: "Wie Innaxys Cookies verwendet?",
        text: [
          "Wenn Sie den Dienst nutzen und darauf zugreifen, können wir eine Anzahl von Cookie-Dateien in Ihrem Webbrowser platzieren.",
          "Wir verwenden Cookies für folgende Zwecke: um bestimmte Funktionen des Dienstes zu ermöglichen, Analysen bereitzustellen, Ihre Präferenzen zu speichern.",
          "Wir verwenden sowohl Sitzungs- als auch persistente Cookies auf dem Dienst und verwenden verschiedene Arten von Cookies, um den Dienst zu betreiben:"
        ],
        textList: [
          "Essenzielle Cookies. Wir können essenzielle Cookies verwenden, um Benutzer zu authentifizieren und betrügerische Nutzung von Benutzerkonten zu verhindern.",
          "Nicht-essenzielle Cookies: Wir verwenden Cookies von Drittanbietern, um die Anzahl der Besucher auf unserer Website zu zählen."
        ]
      },
      {
        header: "Cookies von Drittanbietern",
        text: "Zusätzlich zu unseren eigenen Cookies können wir auch verschiedene Cookies von Drittanbietern verwenden, um Nutzungsstatistiken des Dienstes zu melden, Werbung auf und durch den Dienst bereitzustellen usw."
      },
      {
        header: "Welche Wahlmöglichkeiten haben Sie bezüglich Cookies",
        text: [
          "Wenn Sie Cookies löschen oder Ihren Webbrowser anweisen möchten, Cookies zu löschen oder abzulehnen, besuchen Sie bitte die Hilfeseiten Ihres Webbrowsers.",
          "Bitte beachten Sie jedoch, dass Sie möglicherweise nicht alle von uns angebotenen Funktionen nutzen können, wenn Sie Cookies löschen oder ablehnen, Ihre Präferenzen möglicherweise nicht speichern können und einige unserer Seiten möglicherweise nicht richtig angezeigt werden."
        ]
      },
      {
        header: "Wie man Cookies kontrolliert",
        text: "Sie können Cookies nach Belieben kontrollieren und/oder löschen – weitere Informationen finden Sie unter aboutcookies.org. Sie können alle Cookies löschen, die sich bereits auf Ihrem Computer befinden, und die meisten Browser so einstellen, dass sie das Platzieren von Cookies verhindern. Wenn Sie dies tun, müssen Sie jedoch möglicherweise bei jedem Besuch einer Website einige Einstellungen manuell anpassen, und einige Dienste und Funktionen funktionieren möglicherweise nicht."
      }
    ]
  },
  es: {
    header: "Política de Cookies",
    contents: {
      header: "Contenido",
      listItems: [
        "¿Qué son las cookies?",
        "Cómo utiliza Innaxys las cookies",
        "Cookies de terceros",
        "Cuáles son sus opciones respecto a las cookies",
        "Cómo controlar las cookies",
      ],
    },
    intro: [
      "Innaxys Ltd (“nosotros”, “nos” o “nuestro”) utiliza cookies en innaxys.com (el “Servicio”). Al utilizar el Servicio, usted acepta el uso de cookies.",
      "Nuestra Política de Cookies explica qué son las cookies, cómo las utilizamos, cómo pueden utilizarlas terceros con los que podamos asociarnos en el Servicio, sus opciones con respecto a las cookies y más información sobre ellas.",
    ],
    contexts: [
      {
        header: "¿Cómo utiliza Innaxys las cookies?",
        text: [
          "Cuando usted utiliza y accede al Servicio, podemos colocar varios archivos de cookies en su navegador web.",
          "Usamos cookies para los siguientes propósitos: habilitar ciertas funciones del Servicio, proporcionar análisis y almacenar sus preferencias.",
          "Utilizamos tanto cookies de sesión como persistentes en el Servicio y empleamos distintos tipos de cookies para operar el Servicio:",
        ],
        textList: [
          "Cookies esenciales. Podemos utilizar cookies esenciales para autenticar a los usuarios y prevenir el uso fraudulento de cuentas de usuario.",
          "Cookies no esenciales: Utilizamos cookies de terceros para contar el número de visitantes a nuestro sitio web.",
        ],
      },
      {
        header: "Cookies de terceros",
        text:
          "Además de nuestras propias cookies, también podemos usar diversas cookies de terceros para reportar estadísticas de uso del Servicio, mostrar anuncios en y a través del Servicio, entre otros fines.",
      },
      {
        header: "Cuáles son sus opciones respecto a las cookies",
        text: [
          "Si desea eliminar las cookies o indicar a su navegador que las elimine o rechace, por favor visite las páginas de ayuda de su navegador web.",
          "Tenga en cuenta, sin embargo, que si elimina las cookies o rechaza aceptarlas, puede que no pueda utilizar todas las funciones que ofrecemos, no pueda guardar sus preferencias, y que algunas páginas no se muestren correctamente.",
        ],
      },
      {
        header: "Cómo controlar las cookies",
        text:
          "Puede controlar y/o eliminar las cookies como desee; para más detalles, consulte aboutcookies.org. Puede eliminar todas las cookies que ya se encuentran en su ordenador y puede configurar la mayoría de los navegadores para evitar que se almacenen. Sin embargo, si hace esto, puede que tenga que ajustar manualmente algunas preferencias cada vez que visite un sitio y algunos servicios y funcionalidades podrían no funcionar.",
      },
    ],
  },
};
